var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-wrap" },
    [
      !_vm.item.children || _vm.item.children.length === 0
        ? _c("el-menu-item", { attrs: { index: _vm.item.path } }, [
            _c("span", { attrs: { slot: "title" }, slot: "title" }, [
              _vm._v(_vm._s(_vm.item.title))
            ])
          ])
        : _c(
            "el-submenu",
            { attrs: { index: _vm.item.path } },
            [
              _c("template", { slot: "title" }, [
                _c("span", [_vm._v(_vm._s(_vm.item.title))])
              ]),
              _vm._v(" "),
              _vm._l(_vm.item.children, function(childItem) {
                return _c("sidebar-item", {
                  key: childItem.path,
                  attrs: { item: childItem }
                })
              })
            ],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9b24a14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9b24a14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leftMenu/SidebarItem.vue
// module id = null
// module chunks = 